import type { TouchpointVersionAttributes } from "hooks/api/use-touchpoint-versions";
import { TouchpointType } from "types/touchpoint";

export type TouchpointActionGates = {
  isBlockedByLock: boolean;
  isBlockedByInvalidFields: boolean;
  isBlockedByOpenActionItems: boolean;
  isPublishDisabled: boolean;
};

type GetTouchpointActionGatesProps = {
  selectedVersion?: TouchpointVersionAttributes;
  isLockedByAnotherUser: boolean;
  isTemplate: boolean;
  isApproved: boolean;
  actionItemCount?: number;
};

/**
 * Computes the publish/edit/create-draft blocker flags for a touchpoint version.
 * Templates and `TouchpointType.OTHER` short-circuit publish-only gates so only
 * the lock gate ever fires for them.
 */
export function getTouchpointActionGates({
  selectedVersion,
  isLockedByAnotherUser,
  isTemplate,
  isApproved,
  actionItemCount,
}: GetTouchpointActionGatesProps): TouchpointActionGates {
  const touchpointIsOther = selectedVersion?.type === TouchpointType.OTHER;
  const isPublishableType = !isTemplate && !touchpointIsOther;

  const isBlockedByLock = isLockedByAnotherUser;
  const isBlockedByInvalidFields = isPublishableType && !selectedVersion?.publishable;
  const isBlockedByOpenActionItems = isApproved && isPublishableType && !!actionItemCount;

  return {
    isBlockedByLock,
    isBlockedByInvalidFields,
    isBlockedByOpenActionItems,
    isPublishDisabled: isBlockedByLock || isBlockedByInvalidFields || isBlockedByOpenActionItems,
  };
}
